<template>
    <div>
        <span style="width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
            <NavBar_Fusion></NavBar_Fusion>

            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="12" lg="8" xl="8" style="text-align:center;">
                                     <div class="content-box-toolbar-div">
                                        <v-toolbar class="rounded-lg elevation-5" dark color="#f5f5f5" style="padding:0;text-align:left;height:40px;" density="compact">
                                             <v-toolbar-title style="font-size:16px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                   Fusion Information
                                             </v-toolbar-title>
                                        </v-toolbar>
                                     </div>
                        <v-card class="content-box elevation-4" style="padding-left:10px;padding-right:10px;">
                                        <div class="content-box-header-space"></div>

                                        <div>
                                            <v-table style="margin:00px;padding:10px;border:1px solid grey;">
                                                <tr>
                                                    <td style="width:150px;">Frame</td>
                                                    <td>{{ item.UTA_Adapter_fusion.is_inframe }}</td>
                                                </tr>
                                            </v-table>
                                            <div class="content-box-header-space"></div>
                                            <v-table>
                                                <thead>
                                                    <tr style="background-color:#f0f0f0;">
                                                        <td>Gene name</td>
                                                        <td>Genome Position</td>
                                                        <td>Breakpoint position in transcript</td>
                                                        <td>Position in Frame</td>
                                                        <td>Position in Triplet</td>
                                                        <td>Transcript</td>
                                                        <td>Strand</td>
                                                        <td>Target Exon</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="'UTA_Adapter_fusion' in item">
                                                        <td>{{ item.UTA_Adapter_fusion.input_1.gene_name }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_1.qid }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_1.breakpoint_position_in_transcript }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_1.position_in_frame }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_1.position_in_triplett }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_1.transcript }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_1.strand }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_1.target_exon }}</td>
                                                    </tr>
                                                    <tr v-if="'UTA_Adapter_fusion' in item">
                                                        <td>{{ item.UTA_Adapter_fusion.input_2.gene_name }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_2.qid }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_2.breakpoint_position_in_transcript }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_2.position_in_frame }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_2.position_in_triplett }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_2.transcript }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_2.strand }}</td>
                                                        <td>{{ item.UTA_Adapter_fusion.input_2.target_exon }}</td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </div>

                                    </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </span>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import active_variants from "@/methods/active_variants";
import NavBar_Fusion from "@/components/navbars/NavBar_Fusion";

export default {
    name: 'FusionSummary',
    props: {
    },
    components: {
        Loading,
        NavBar_Fusion,
    },
    data: function() {
        return {
            isLoading: false,
            fullPage: true,
        }
    },
    methods: {
    },
    created: async function() {
        //alert(this.$route.fullPath)

        this.isLoading=true
        await active_variants.loadActiveBiomarkerFusion(this.$route.params.id)
        this.isLoading=false

    }
}
</script>
<style>
</style>
